import { type FC, Fragment } from "react";
import { InformationBox } from "@clientFrontend/features/scout/components/InformationBox";
import { Icon } from "@root/shared/components/Icon";
import { type MultiActionItem } from ".";
import * as styles from "./styles.css";

type PresentationProps = {
  multiActionInfo: MultiActionItem[];
  isIconFire: boolean;
  showReadMoreButton?: boolean;
  hasMultiWorksInfo: boolean;
  isClickedReadMoreButton: boolean[];
  lineCount: number;
  handleShowContent: (index: number) => void;
  textRef: React.RefObject<HTMLSpanElement>;
};

export const Presentation: FC<PresentationProps> = ({
  multiActionInfo,
  isIconFire,
  showReadMoreButton = false,
  hasMultiWorksInfo = false,
  isClickedReadMoreButton,
  lineCount,
  handleShowContent,
  textRef,
}) => {
  // TODO:現状のIconコンポーネントではBreakpointsでcssを変更できないため一旦直書きにしています
  const renderFireIcon = (shouldRender: boolean) => {
    return shouldRender ? <i className={`c-icn c-icn-fire ${styles.fireIcon}`} /> : null;
  };

  const renderWorkText = (isHot: boolean, text: string, key: string) => (
    <span key={key} ref={textRef} className={styles.infoText}>
      {renderFireIcon(isHot)}
      {text}
    </span>
  );

  const renderWorkTextsWithReadMoreButton = (
    isHot: boolean,
    workTexts: string[],
    outerIndex: number,
  ) => {
    if (workTexts.length === 0) return null;

    return (
      <>
        {/* "worksを2件以上持っていて、かつ「さらに表示」を押下されていない" あるいは、
          "行数が３行以上で、かつ「さらに表示」を押下されていない"場合に
          「さらに表示」を表示する */}
        {(hasMultiWorksInfo && !isClickedReadMoreButton[outerIndex]) ||
        (lineCount >= 3 && !isClickedReadMoreButton[outerIndex]) ? (
          <>
            <span className={styles.isHiddenInfoText}>
              {renderFireIcon(isHot)}
              {workTexts[0]}
            </span>
            <button
              onClick={() => handleShowContent(outerIndex)}
              className={styles.readMoreButton}
              type="button"
            >
              <Icon name="arrow-light-down" />
              さらに表示
            </button>
          </>
        ) : (
          workTexts.map((text, index) =>
            renderWorkText(isHot, text, `worktext_${outerIndex}_${index}`),
          )
        )}
      </>
    );
  };

  return (
    <>
      {multiActionInfo.map(({ works, actionText, isHot }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <InformationBox key={`${actionText}_${index}`} className={styles.informationBox}>
          <b>
            {actionText}
            {hasMultiWorksInfo && showReadMoreButton && (
              <span className={styles.lengthText}>※他{works.length - 1}件</span>
            )}
          </b>
          <br />
          <p className={styles.actionInfo}>
            {showReadMoreButton
              ? works.map((infoText, textIndex) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Fragment key={textIndex}>
                    {textIndex === 0
                      ? renderWorkTextsWithReadMoreButton(isHot, [infoText], index)
                      : isClickedReadMoreButton[index] &&
                        renderWorkText(isHot, infoText, `worktext_${index}_${textIndex}`)}
                  </Fragment>
                ))
              : works.map((infoText, textIndex) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Fragment key={textIndex}>
                    {renderWorkText(isHot, infoText, `worktext_${index}_${textIndex}`)}
                  </Fragment>
                ))}
          </p>
        </InformationBox>
      ))}
      {isIconFire && (
        <p className={styles.annotation}>
          {renderFireIcon(true)}
          …直近30日以内にアクションがあった求人です。応募の可能性が高く、スカウトのチャンスです！
        </p>
      )}
    </>
  );
};
